import React from 'react';
import Header from './Header';
import FootBar from './Footer';
import Content from './Content';
import { Location } from '@reach/router';

class MainLayout extends React.Component<{}> {
	render() {
		return (
			<React.Fragment>
				<Location>
					{({ location }) => {
						return (
							<React.Fragment>
								<Header location={location} />
								<Content>{this.props.children}</Content>
								<FootBar />
							</React.Fragment>
						);
					}}
				</Location>
			</React.Fragment>
		);
	}
}

export default MainLayout;
